// extracted by mini-css-extract-plugin
module.exports = {"description":"Content_description__35bUy","field":"Content_field__DV40T","editor":"Content_editor__1ZVP8","group":"Content_group__2C3CM"};